<template>
  <div class="template">
    <templateList ref="list"></templateList>
    <router-view @list-reload="listReload" />
  </div>
</template>

<script>
import templateList from './templateList.vue'

export default {
  components: {
    templateList
  },
  methods: {
    async listReload() {
      await this.$refs.list.reload()
    }
  }
}
</script>
<style scoped>
.template {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/template/template.vue